export enum Themes
{
  LIGHT = 'light',
  DARK  = 'dark'
}
